const UpdateChannelAccessLevels = {
    1: "Private",
    2: "Public",
    3: "Restricted"
};
Object.freeze(UpdateChannelAccessLevels);

export { UpdateChannelAccessLevels }